import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function isAnalyticsEnabled() {
  return (process.env.REACT_APP_ANALYTICS_ENABLED || "").toLowerCase() === "true";
}

function getAnalyticsEndpoint() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
  return `${backendUrl}/api/analytics/events`;
}

function normalizeAnalyticsPath(pathname) {
  const segments = pathname.split("/").filter(Boolean);

  if (segments[0] === "rsvp" && segments[1]) {
    return "/rsvp/:token";
  }

  if (segments[0] === "w" && segments[1]) {
    if (segments[2] === "guest-upload") {
      return "/w/:slug/guest-upload";
    }
    return "/w/:slug";
  }

  const normalizedSegments = segments.map((segment) => (
    /^[a-f0-9-]{8,}$/i.test(segment) || /^[A-Za-z0-9_-]{16,}$/.test(segment)
      ? ":id"
      : segment
  ));

  return normalizedSegments.length ? `/${normalizedSegments.join("/")}` : "/";
}

function sendEvent(payload) {
  const body = JSON.stringify(payload);
  const endpoint = getAnalyticsEndpoint();

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    navigator.sendBeacon(endpoint, blob);
    return;
  }

  fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

function getReferrerRoute() {
  if (!document.referrer) {
    return null;
  }

  try {
    return normalizeAnalyticsPath(new URL(document.referrer).pathname);
  } catch {
    return null;
  }
}

export default function AnalyticsBridge() {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) {
      return;
    }

    sendEvent({
      kind: "page_view",
      route: normalizeAnalyticsPath(location.pathname),
      referrer_route: getReferrerRoute(),
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      occurred_at: new Date().toISOString(),
    });
  }, [location.pathname]);

  return null;
}

export { normalizeAnalyticsPath };
